<template>
    <router-view/>
</template>

<script>
export default {
  name: "DashboardBase",
  data() {
    return {
      items: [
        { title: "Home", icon: "mdi-view-dashboard", to: "/dashboard" },
        { title: "New Order", icon: "mdi-text-box-plus", to: "/dashboard/new-order"  },
        { title: "Order History", icon: "mdi-text-box-multiple", to: "/dashboard/orders"  },
      ],
      right: null,
    };
  },
  computed: {
    currentView() {
      return this.$route.name
    }
  }
};
</script>
